import { toTitleCasedKeys } from '@agilepoint/utils-common';
import { IAnnouncementParam, useCreateAnnouncementQuery } from 'modules/shared/queries';
import React from 'react';
import { CreateAccouncement } from '../component/parts/user-details/create-announcement';
import { useConfigScopeSelectors } from '../scopes';

export function CreateAnnouncementContainer(props: { removePopup: (id: string) => void }) {
    const { mutateAsync } = useCreateAnnouncementQuery();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();

    const saveAnnouncementInfo = React.useCallback((formData: IAnnouncementParam) => mutateAsync({
        announcement: toTitleCasedKeys(formData),
        createdBy: currentUserDetails.userName
    }), [currentUserDetails.userName, mutateAsync]);

    return (
        <CreateAccouncement saveAnnouncementInfo={saveAnnouncementInfo} removePopup={props.removePopup} popupId="create-announcement" />
    );
}
